<ion-header class="ion-no-border app-inner-padding">
	<ion-grid class="ion-no-padding">
		<ion-row class="ion-no-padding">
			<ion-col size="9">
				<ion-title size="small" class="ion-no-padding">{{ 'entry.export.title' | translate }}</ion-title>
			</ion-col>
			<ion-col size="3">
				<ion-buttons>
					<ion-button class="ion-no-padding" (click)="close()">
						<ion-icon class="icon-Close"></ion-icon>
					</ion-button>
				</ion-buttons>
			</ion-col>
		</ion-row>
	</ion-grid>
</ion-header>
<ion-content>
	<ion-grid class="ion-justify-content-between">
		<ion-row class="ion-padding">
			<ion-list class="ion-padding-top">
				<ion-radio-group [value]="fileExporterOption.xlsx" (ionChange)="onValueChange($event)">
					<ion-item
						[ngClass]="{
							selected: selectedOption === fileExporterOption.xlsx
						}"
						(click)="chooseOption(fileExporterOption.xlsx)"
					>
						<ion-icon class="icon-xlsx"></ion-icon>
						<ion-radio [value]="fileExporterOption.xlsx"></ion-radio>
					</ion-item>

					<ion-item
						[ngClass]="{
							selected: selectedOption === fileExporterOption.csv
						}"
						(click)="chooseOption(fileExporterOption.csv)"
					>
						<ion-icon class="icon-csv"></ion-icon>
						<ion-radio [value]="fileExporterOption.csv"></ion-radio>
					</ion-item>

					<ion-item
						[ngClass]="{
							selected: selectedOption === fileExporterOption.pdf
						}"
						(click)="chooseOption(fileExporterOption.pdf)"
					>
						<ion-icon class="icon-pdf"></ion-icon>
						<ion-radio [value]="fileExporterOption.pdf"></ion-radio>
					</ion-item>
				</ion-radio-group>
			</ion-list>
		</ion-row>
		<ion-row class="ion-padding">
			<ion-button (click)="export()">
				{{ 'entry.export.buttonTitle' | translate }}
			</ion-button>
		</ion-row>
	</ion-grid>
</ion-content>
